import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

export const Header = ({ lang, setLang, t }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItems = [
    { id: "collection", label: t.nav.collection },
    { id: "heritage",   label: t.nav.heritage },
    { id: "lookbook",   label: t.nav.lookbook },
    { id: "newsletter", label: t.nav.journal },
    { id: "contact",    label: t.nav.contact },
  ];

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#110F0E]/85 border-b border-[#3A342E]"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-12 lg:px-16 py-5">
        <button
          data-testid="brand-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-serif text-[#F3EFE9] text-2xl md:text-[28px] tracking-[0.18em] font-light"
        >
          KAFKAZ<span className="text-[#A67A53]">STYLE</span>
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {navItems.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}-link`}
              onClick={() => scrollTo(item.id)}
              className="overline link-underline text-[#F3EFE9]"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden md:flex items-center gap-2 font-mono text-xs tracking-[0.2em] border border-[#3A342E] rounded-none">
            <button
              data-testid="lang-en-btn"
              onClick={() => setLang("en")}
              className={`px-3 py-2 transition-colors ${
                lang === "en"
                  ? "bg-[#7A2828] text-[#F3EFE9]"
                  : "text-[#9D9287] hover:text-[#F3EFE9]"
              }`}
            >
              EN
            </button>
            <button
              data-testid="lang-ru-btn"
              onClick={() => setLang("ru")}
              className={`px-3 py-2 transition-colors ${
                lang === "ru"
                  ? "bg-[#7A2828] text-[#F3EFE9]"
                  : "text-[#9D9287] hover:text-[#F3EFE9]"
              }`}
            >
              RU
            </button>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 text-[#F3EFE9]"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#110F0E]/95 backdrop-blur-xl border-t border-[#3A342E] px-6 py-8 flex flex-col gap-6"
        >
          {navItems.map((item) => (
            <button
              key={item.id}
              data-testid={`mobile-nav-${item.id}-link`}
              onClick={() => scrollTo(item.id)}
              className="text-left font-serif text-3xl text-[#F3EFE9]"
            >
              {item.label}
            </button>
          ))}
          <div className="flex items-center gap-2 pt-4">
            <button
              data-testid="mobile-lang-en-btn"
              onClick={() => setLang("en")}
              className={`px-3 py-2 font-mono text-xs tracking-[0.2em] border border-[#3A342E] ${
                lang === "en" ? "bg-[#7A2828] text-[#F3EFE9]" : "text-[#9D9287]"
              }`}
            >EN</button>
            <button
              data-testid="mobile-lang-ru-btn"
              onClick={() => setLang("ru")}
              className={`px-3 py-2 font-mono text-xs tracking-[0.2em] border border-[#3A342E] ${
                lang === "ru" ? "bg-[#7A2828] text-[#F3EFE9]" : "text-[#9D9287]"
              }`}
            >RU</button>
          </div>
        </div>
      )}
    </header>
  );
};
